import { render, staticRenderFns } from "./SingleBundle.vue?vue&type=template&id=7d0167f8&"
import script from "./SingleBundle.vue?vue&type=script&lang=js&"
export * from "./SingleBundle.vue?vue&type=script&lang=js&"
import style0 from "./SingleBundle.vue?vue&type=style&index=0&id=7d0167f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports